import React, { useState } from 'react';
import T from '../styles/theme';
import Icon from './Icon';
import apiFetch from '../data/api';

/**
 * ChangeHistorySection — extracted from ContactRecord's inline block.
 * Parameterized via entityType + entityId so it can mount on any record page.
 *
 * The underlying /api/audit endpoint already accepts entityType as a parameter;
 * the inline version just hardcoded "contact". This version simply passes the
 * prop through unchanged.
 */
export default function ChangeHistorySection({ entityType, entityId }) {
  const [logs, setLogs] = useState([]);
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const load = async () => {
    if (loaded) { setOpen(!open); return; }
    setOpen(true);
    try {
      const resp = await apiFetch("/api/audit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "list", entityType, entityId, limit: 25 }),
      });
      const data = await resp.json();
      setLogs(data.logs || []);
      setLoaded(true);
    } catch (e) { console.error("Audit load failed:", e); }
  };

  const fmtD = (d) => { if (!d) return ""; const dt = new Date(d); return (dt.getMonth()+1)+"/"+dt.getDate()+" "+dt.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }); };

  return (
    <div style={{ marginTop: 2 }}>
      <div onClick={load} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", cursor: "pointer" }}>
        <div style={{ fontSize: 11, fontWeight: 400, color: T.txt }}>Change History {logs.length > 0 ? `(${logs.length})` : ""}</div>
        <Icon name={open ? "chevron-up" : "chevron-down"} size={12} color={T.txt} />
      </div>
      {open && (
        <div>
          {logs.length === 0 && <div style={{ fontSize: 11, color: T.tx3, padding: "8px 0" }}>No changes recorded yet</div>}
          {logs.map(log => (
            <div key={log.id} style={{ padding: "6px 0", borderBottom: "1px solid " + T.bdr, fontSize: 11 }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span style={{ color: T.txt }}>{log.user_name || "System"}</span>
                <span style={{ color: T.tx3, fontSize: 10 }}>{fmtD(log.created_at)}</span>
              </div>
              {log.changes && Object.entries(typeof log.changes === "string" ? JSON.parse(log.changes) : log.changes).map(([field, vals]) => (
                <div key={field} style={{ marginTop: 2, fontSize: 10, color: T.tx3 }}>
                  {field}: <span style={{ color: "#E53935", textDecoration: "line-through" }}>{vals.old || "empty"}</span> → <span style={{ color: "#00D68F" }}>{vals.new || "empty"}</span>
                </div>
              ))}
              {log.action === "stage_change" && (
                <div style={{ marginTop: 2, fontSize: 10, color: T.tx3 }}>
                  stage: <span style={{ color: "#E53935" }}>{log.old_value}</span> → <span style={{ color: "#00D68F" }}>{log.new_value}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
